import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ContentRevision from "./ContentRevision";
import ContentRevisionHeader from "./ContentRevisionHeader";
import ContentRevisionAbout from "./ContentRevisionAbout";
import ContentRevisionQuick from "./ContentRevisionQuick";
import ContentRevisionTerm from "./ContentRevisionTerm";
import ContentRevisionFaq from "./ContentRevisionFaq";
import CreateHeaderContentForm from "./forms/CreateHeaderContentForm";
import AboutTheCampaignForm from "./forms/AboutTheCampaignForm";
import QuickReadContentForm from "./forms/QuickReadContentForm";
import TermAndConditionForm from "./forms/TermAndConditionForm";
import FAQContentFrom from "./forms/FAQContentFrom";
import AccordionComponent from "../../../../../_uiComponents/common/AccordionComponent";
import { incentiveAboutContentGetRequest, incentiveFaqContentGetRequest, incentiveHeaderContentGetRequest, incentiveQuickContentGetRequest, incentiveRevisionGetRequest, incentiveTermContentGetRequest } from "../../../../../../_redux/_actions";

export default function Content(props) {

     const actionDispatch = useDispatch();

     const { id } = useParams();
     const campaignId = parseInt(id);
     const [expanded, setExpanded] = React.useState('HeaderContent');
    
     const handleChange = (panel) => (event, isExpanded) => {
         setExpanded(isExpanded ? panel : false);
         if(panel === 'AboutCampaign' && isExpanded){  
               
         }
    };

    const loadHeaderRevisionData = (id) => {
     if (!id) return;
     actionDispatch(incentiveHeaderContentGetRequest({ id }));
    }

    const loadAboutRevisionData = (id) => {
     if (!id) return;
     actionDispatch(incentiveAboutContentGetRequest({id}));
    }

    const loadQuickRevisionData = (id) => {
     if (!id) return;
      actionDispatch(incentiveQuickContentGetRequest({id}));
    }

    const loadTermRevisionData = (id) => {
     if (!id) return;
     actionDispatch(incentiveTermContentGetRequest({id}));
   }

   const loadFaqRevisionData = (id) => {
     if (!id) return;
     actionDispatch(incentiveFaqContentGetRequest({id}));
   }

     return (
          <>
               <AccordionComponent  
                    expanded={expanded === 'HeaderContent'}
                    handleChange={handleChange('HeaderContent')}
                    title="Header Content">
                    <CreateHeaderContentForm loadHeaderRevisionData={loadHeaderRevisionData} campaignId={campaignId}/>
                    <label className="sba-content-label">
                         Content Revision
                    </label>
                    <ContentRevisionHeader loadHeaderRevisionData={loadHeaderRevisionData} campaignId={campaignId}/>
               </AccordionComponent>
               <AccordionComponent 
               expanded={expanded === 'AboutCampaign'}
               handleChange={handleChange('AboutCampaign')}
               title="About Campaign">
                    <AboutTheCampaignForm loadAboutRevisionData={loadAboutRevisionData} campaignId={campaignId} />
                    <label className="sba-content-label">
                         Content Revision
                    </label>
                    <ContentRevisionAbout loadAboutRevisionData={loadAboutRevisionData} campaignId={campaignId} />
               </AccordionComponent>
               {/* <AccordionComponent 
               expanded={expanded === 'QuickRead'}
               handleChange={handleChange('QuickRead')}
               title="Quick Read">
                    <QuickReadContentForm loadQuickRevisionData={loadQuickRevisionData} campaignId={campaignId} />
                    <label className="sba-content-label">
                         Content Revision
                    </label>
                    <ContentRevisionQuick loadQuickRevisionData={loadQuickRevisionData} campaignId={campaignId} />
               </AccordionComponent> */}
               <AccordionComponent 
               expanded={expanded === 'TermsCondition'}
               handleChange={handleChange('TermsCondition')}
               title="Terms & Condition ">
                    <TermAndConditionForm loadTermRevisionData={loadTermRevisionData} campaignId={campaignId} />
                    <label className="sba-content-label">
                         Content Revision
                    </label>
                    <ContentRevisionTerm  loadTermRevisionData={loadTermRevisionData} campaignId={campaignId}   />
               </AccordionComponent>
               <AccordionComponent
                expanded={expanded === 'FAQ'}
                handleChange={handleChange('FAQ')}
                 title="Frequently Asked Question">
                    <FAQContentFrom loadFaqRevisionData={loadFaqRevisionData} campaignId={campaignId} />
                    <label className="sba-content-label">
                         Content Revision
                    </label>
                    <ContentRevisionFaq loadFaqRevisionData={loadFaqRevisionData} campaignId={campaignId} />
               </AccordionComponent>
          </>
     );
}
